// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradeConfirmPublishStepQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  draftScheduleInput: Types.DraftScheduleInput;
}>;


export type TradeConfirmPublishStepQuery = { __typename?: 'Query', draftPlanSchedule: { __typename?: 'DraftScheduleResult', tradeConfirmPlanTasks: Array<{ __typename?: 'PlanTask', id: string, name: string, startDate: Types.Scalars['Date']['input'], knownSchedulingContacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, contactsForMarket: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined } | null | undefined> } | null | undefined }>, planTasks: Array<{ __typename?: 'PlanTask', id: string }>, planSchedule: { __typename?: 'PlanSchedule', id: string }, newlyCompletedPlanTasks: Array<{ __typename?: 'PlanTask', id: string }> } };

export type TradeConfirmPublishStep_PlanTaskFragment = { __typename?: 'PlanTask', id: string, name: string, startDate: Types.Scalars['Date']['input'], knownSchedulingContacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, contactsForMarket: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined } | null | undefined> } | null | undefined };

export type TradeConfirmPublishStep_TradePartnerFragment = { __typename?: 'TradePartner', id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, contactsForMarket: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined } | null | undefined> };

export type TradeConfirmPublishStep_TradePartnerContactFragment = { __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined };

export const TradeConfirmPublishStep_TradePartnerContactFragmentDoc = gql`
    fragment TradeConfirmPublishStep_TradePartnerContact on TradePartnerContact {
  id
  name
  email
}
    `;
export const TradeConfirmPublishStep_TradePartnerFragmentDoc = gql`
    fragment TradeConfirmPublishStep_TradePartner on TradePartner {
  id
  name
  markets {
    ...Named
  }
  contactsForMarket(projectDevelopmentMarketId: $projectId) {
    ...TradeConfirmPublishStep_TradePartnerContact
  }
}
    ${NamedFragmentDoc}
${TradeConfirmPublishStep_TradePartnerContactFragmentDoc}`;
export const TradeConfirmPublishStep_PlanTaskFragmentDoc = gql`
    fragment TradeConfirmPublishStep_PlanTask on PlanTask {
  id
  name
  startDate
  knownSchedulingContacts {
    ...TradeConfirmPublishStep_TradePartnerContact
  }
  tradePartner {
    ...TradeConfirmPublishStep_TradePartner
  }
}
    ${TradeConfirmPublishStep_TradePartnerContactFragmentDoc}
${TradeConfirmPublishStep_TradePartnerFragmentDoc}`;
export const TradeConfirmPublishStepDocument = gql`
    query TradeConfirmPublishStep($projectId: ID!, $draftScheduleInput: DraftScheduleInput!) {
  draftPlanSchedule(input: $draftScheduleInput) {
    tradeConfirmPlanTasks {
      ...TradeConfirmPublishStep_PlanTask
    }
    planTasks {
      id
    }
    planSchedule {
      id
    }
    newlyCompletedPlanTasks {
      id
    }
  }
}
    ${TradeConfirmPublishStep_PlanTaskFragmentDoc}`;

/**
 * __useTradeConfirmPublishStepQuery__
 *
 * To run a query within a React component, call `useTradeConfirmPublishStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeConfirmPublishStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeConfirmPublishStepQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      draftScheduleInput: // value for 'draftScheduleInput'
 *   },
 * });
 */
export function useTradeConfirmPublishStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradeConfirmPublishStepQuery, TradeConfirmPublishStepQueryVariables> & ({ variables: TradeConfirmPublishStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeConfirmPublishStepQuery, TradeConfirmPublishStepQueryVariables>(TradeConfirmPublishStepDocument, options);
      }
export function useTradeConfirmPublishStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeConfirmPublishStepQuery, TradeConfirmPublishStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeConfirmPublishStepQuery, TradeConfirmPublishStepQueryVariables>(TradeConfirmPublishStepDocument, options);
        }
export function useTradeConfirmPublishStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradeConfirmPublishStepQuery, TradeConfirmPublishStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradeConfirmPublishStepQuery, TradeConfirmPublishStepQueryVariables>(TradeConfirmPublishStepDocument, options);
        }
export type TradeConfirmPublishStepQueryHookResult = ReturnType<typeof useTradeConfirmPublishStepQuery>;
export type TradeConfirmPublishStepLazyQueryHookResult = ReturnType<typeof useTradeConfirmPublishStepLazyQuery>;
export type TradeConfirmPublishStepSuspenseQueryHookResult = ReturnType<typeof useTradeConfirmPublishStepSuspenseQuery>;
export type TradeConfirmPublishStepQueryResult = Apollo.QueryResult<TradeConfirmPublishStepQuery, TradeConfirmPublishStepQueryVariables>;